module.exports = __webpack_public_path__ + "static/img/2bg_9.2dd4a73.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_9.png
// module id = 684
// module chunks = 1